import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Reservation } from '@app/models/micro';
import { IropsService } from '@app/services/micro/irops.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { IropsDeleteCHKModalComponent } from '@app/shared/modals/irops-delete-chk-modal/irops-delete-chk-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessagesService } from '@app/services/messages.service';
import { messageParamsGeneric } from '@app/utils';
import { TypesErrors } from '@app/enums/errors.enum';
import { ErrorModel } from '@models/micro/error.model';
import { IropsMapper } from '@app/mappers';
import { IROPS_STATUS } from '@app/enums/irops.enum';

@Component({
  selector: 'banner-irops-rebrand',
  templateUrl: './banner-irops-rebrand.component.html',
  styleUrls: ['./banner-irops-rebrand.component.scss'],
  standalone: false,
})
export class BannerIropsRebrandComponent implements OnInit {
  @Input() copyTextMain = '';
  @Input() iropsType: IROPS_STATUS;
  @Input() showButtonChangeFlight = true;
  @Input() copyButtonBanner = '';
  @Input() isCancel = false;
  reservation: Reservation;

  constructor(
    private _router: Router,
    private _iropsServ: IropsService,
    private _globalsService: GlobalsService,
    private modalService: NgbModal,
    private _messages: MessagesService
  ) {}

  get bannerClass(): Record<string, boolean> {
    return {
      'cancel-banner': this.isCancel,
      'delayed-banner': !this.isCancel && this.iropsType === IROPS_STATUS.DELAYED,
      'early-banner': !this.isCancel && this.iropsType === IROPS_STATUS.EARLY,
    };
  }

  ngOnInit(): void {
    this.reservation = this._globalsService.getReservation();
  }

  onReviewOptions() {
    const hasPaxWithCheckin = this.reservation?.passengers?.some(p => p.checkinStatus);

    if (hasPaxWithCheckin) {
      // Hay pasajeros con check-in, insertar remark y mostrar modal
      this.setSSR();
    } else {
      this._router.navigate(['notice-proposed-flight']);
    }
  }

  onChangeFlight() {
    this._router.navigate(['/srIrops/newFlight']);
  }

  setSSR(): void {
    const remarkParams = IropsMapper.buildRemarkParams(this.reservation, 'CONFIT', this._iropsServ.affectationType);

    this._iropsServ.sendIropsRemark(this.reservation, remarkParams).subscribe({
      next: (data) => {
        this._iropsServ.pnrData = data;
        const hasPaxWithCheckin: boolean = this.reservation?.passengers?.some(p => p.checkinStatus);

        if (hasPaxWithCheckin) {
          const modalRef = this.modalService.open(IropsDeleteCHKModalComponent,
            {
              centered: true,
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
            }
          );
        } else {
          this._router.navigate(['notice-proposed-flight']);
        }
      },
      error: (err) => {
        this.showMessageBlock();
      }
    });
  }

  private showMessageBlock(): void {
    const error = new ErrorModel().withCode('99').withMessage('Error in remove check-in');
    this._messages.error(
      {
        typesError: TypesErrors.ERROR_IN_REMARK,
        error
      },
      null,
      TypesErrors.ERROR_IN_REMARK,
      messageParamsGeneric
    ).finally(()=>{
      this.modalService.dismissAll("close");
      this._router.navigate(['/']);
    });
  }

  removeCheckIn(): void {
    this._iropsServ.removeCHKN(this.reservation).subscribe({
      next: (response) => {
        console.log("response", response);
        if (response.status === 'success') {
          this._router.navigate(['notice-proposed-flight']);
        }
      },
      error: (err) => {
        this.showMessageBlock()
      }
    })
  }

  comercialConfrim(reservation: Reservation) {
    const cancelWk = reservation.flightSummary?.segments?.some(segment => segment.isCancelOag);
    if (cancelWk) {
      this._router.navigate(['notice-proposed-flight']);
    } else {
      this._iropsServ.comercialConfirmation(this.reservation).subscribe({
        next: res => {
          this._router.navigate(['notice-proposed-flight']);
        },
        error: error => {

          this.showMessageBlock();
        }
      })
    }
  }
}
